import { useQueries } from '@tanstack/react-query';
import gqlFetcher from '../gqlFetcher_myf2b';
const noop = d => d;
const useGqlQueries = (queries, fetcher = gqlFetcher) => useQueries({
  queries: queries.map(({
    document,
    variables = {},
    options: {
      transformer = noop,
      ...options
    }
  }) => ({
    ...options,
    queryFn: () => fetcher({
      document,
      variables
    }).then(transformer)
  }))
});
const prependQueryKey = (keysToPrepend, queries) => queries.map(({
  options: {
    queryKey,
    ...opts
  },
  ...rest
}) => ({
  ...rest,
  options: {
    ...opts,
    queryKey: keysToPrepend.concat(queryKey)
  }
}));
export const useUiQueries = (queries, fetcher = gqlFetcher) => useGqlQueries(prependQueryKey(['ui'], queries), fetcher);
export const useMetricQueries = (queries, fetcher = gqlFetcher) => useGqlQueries(prependQueryKey(['authed', 'metric'], queries), fetcher);